import React from "react";
import { commonPostApi } from "../../../utils/apiService";
import { API_ENDPOINTS } from "../../../utils/apiEndpoints";
import CommonModal from "../../common/commonModel";
import AddButtonSection from "../../common/AddButtonSection";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../common/toast";
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../../constants/toast";

export default function PatientDeleteConfirmation({ visible, setVisible, ...props }) {
  const navigate = useNavigate();
  const deletePatientConfirmation = async () => {
    await commonPostApi(API_ENDPOINTS.DELETE_PATIENT_DETAILS, {
      patient_id: props?.patient?.patient_id,
    }).then((data) => {
      if(data?.status == 200){
        showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.PATIENT.DELETED);
        setVisible?.(false, true);
        !props.patientPage && navigate("/patients");
      } else {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      }
    });
  };

  const submitButtons = [
    {
      type: "primarySuccessButton",
      label: "Yes",
      class: "w-8rem pr-3",
      onClick: () => {
        deletePatientConfirmation()
      },
    },
    {
      type: "secondaryButton",
      label: "No",
      class: "w-7rem",
      onClick: () => {
        setVisible?.(false);
      },
    },
  ];

  return (
    <div>
      <CommonModal
        visible={visible}
        header="Delete Patient"
        onHide={() => setVisible(false)}
      >
        <div>
          <div className="flex justify-content-center pr-4">
            Would you like to delete this patient?
          </div>

          <div className="mt-6 ml-2">
            <AddButtonSection buttons={submitButtons} />
          </div>
        </div>
      </CommonModal>
    </div>
  );
}
